import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { shouldInsertTrailingParagraphAfter } from './placeholderCalloutBlock'

const trailingNodePluginKey = new PluginKey('placeholderCalloutTrailingNode')

/**
 * Ensures an empty paragraph after a section-ending placeholder callout so the
 * user can type without dismissing the callout.
 */
export const PlaceholderCalloutTrailingNode = Extension.create({
  name: 'placeholderCalloutTrailingNode',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: trailingNodePluginKey,
        appendTransaction(_transactions, _oldState, newState) {
          const paragraphType = newState.schema.nodes.paragraph
          if (paragraphType == null) {
            return null
          }

          if (!shouldInsertTrailingParagraphAfter(newState.doc.lastChild)) {
            return null
          }

          return newState.tr
            .insert(newState.doc.content.size, paragraphType.create())
            .setMeta('addToHistory', false)
        },
      }),
    ]
  },
})
